module.exports = __webpack_public_path__ + "static/img/ic_address_detail@2x.8dede75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_address_detail@2x.png
// module id = 3QSr
// module chunks = 1